import { ArrowUpRight, Send } from "lucide-react";
import { HonorLogo } from "./Logo";

const SOCIALS = [
  {
    name: "YouTube",
    href: "https://www.youtube.com/@Honortrading",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M23.5 6.2c-.3-1.1-1.1-1.9-2.2-2.2C19.3 3.5 12 3.5 12 3.5s-7.3 0-9.3.5C1.6 4.3.8 5.1.5 6.2 0 8.2 0 12 0 12s0 3.8.5 5.8c.3 1.1 1.1 1.9 2.2 2.2 2 .5 9.3.5 9.3.5s7.3 0 9.3-.5c1.1-.3 1.9-1.1 2.2-2.2.5-2 .5-5.8.5-5.8s0-3.8-.5-5.8zM9.5 15.6V8.4l6.2 3.6-6.2 3.6z" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/honortrading.academy/",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M12 2.2c3.2 0 3.6 0 4.8.1 1.2.1 1.8.2 2.2.4.6.2 1 .5 1.4.9.4.4.7.9.9 1.4.2.4.4 1 .4 2.2.1 1.2.1 1.6.1 4.8s0 3.6-.1 4.8c-.1 1.2-.2 1.8-.4 2.2-.2.6-.5 1-.9 1.4-.4.4-.9.7-1.4.9-.4.2-1 .4-2.2.4-1.2.1-1.6.1-4.8.1s-3.6 0-4.8-.1c-1.2-.1-1.8-.2-2.2-.4-.6-.2-1-.5-1.4-.9-.4-.4-.7-.9-.9-1.4-.2-.4-.4-1-.4-2.2-.1-1.2-.1-1.6-.1-4.8s0-3.6.1-4.8c.1-1.2.2-1.8.4-2.2.2-.6.5-1 .9-1.4.4-.4.9-.7 1.4-.9.4-.2 1-.4 2.2-.4 1.2-.1 1.6-.1 4.8-.1M12 0C8.7 0 8.3 0 7.1.1 5.8.1 5 .3 4.2.6c-.8.3-1.5.8-2.2 1.4C1.4 2.7.9 3.4.6 4.2.3 5 .1 5.8.1 7.1 0 8.3 0 8.7 0 12s0 3.7.1 4.9c.1 1.3.3 2.1.6 2.9.3.8.8 1.5 1.4 2.2.7.7 1.4 1.1 2.2 1.4.8.3 1.6.5 2.9.6 1.2.1 1.6.1 4.9.1s3.7 0 4.9-.1c1.3-.1 2.1-.3 2.9-.6.8-.3 1.5-.8 2.2-1.4.7-.7 1.1-1.4 1.4-2.2.3-.8.5-1.6.6-2.9.1-1.2.1-1.6.1-4.9s0-3.7-.1-4.9c-.1-1.3-.3-2.1-.6-2.9-.3-.8-.8-1.5-1.4-2.2C21.3 1.4 20.6.9 19.8.6 19 .3 18.2.1 16.9.1 15.7 0 15.3 0 12 0zm0 5.8c-3.4 0-6.2 2.8-6.2 6.2s2.8 6.2 6.2 6.2 6.2-2.8 6.2-6.2-2.8-6.2-6.2-6.2zm0 10.2c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm7.8-10.4c0 .8-.6 1.4-1.4 1.4s-1.4-.6-1.4-1.4.6-1.4 1.4-1.4 1.4.6 1.4 1.4z" />
      </svg>
    ),
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@honortrading.academy",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" />
      </svg>
    ),
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61574449903949",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M24 12a12 12 0 1 0-13.88 11.85v-8.38H7.08V12h3.04V9.36c0-3 1.79-4.67 4.53-4.67 1.31 0 2.68.24 2.68.24v2.95h-1.51c-1.49 0-1.95.93-1.95 1.87V12h3.33l-.53 3.47h-2.8v8.38A12 12 0 0 0 24 12z" />
      </svg>
    ),
  },
  {
    name: "WhatsApp",
    href: "https://wa.me/message/KCUAHIJYYYTEK1",
    icon: (
      <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
        <path d="M17.5 14.4c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.4-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5s-.7-1.6-.9-2.2c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1.1 1-1.1 2.5c0 1.5 1.1 2.9 1.2 3.1.1.2 2.1 3.3 5.1 4.6.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.2-.1-.4-.1-.7-.3zM12 2C6.5 2 2 6.5 2 12c0 1.8.5 3.5 1.3 5L2 22l5.2-1.4c1.4.8 3.1 1.2 4.8 1.2 5.5 0 10-4.5 10-10S17.5 2 12 2zm5.9 14.2c-.3.8-1.7 1.5-2.3 1.5-.6.1-1.4.1-2.2-.1-.5-.2-1.1-.4-1.9-.7-3.3-1.4-5.5-4.8-5.7-5-.2-.2-1.3-1.8-1.3-3.5 0-1.6.8-2.4 1.1-2.7.3-.3.7-.4 1-.4h.7c.2 0 .5-.1.8.6.3.8 1 2.6 1.1 2.8.1.2.1.4 0 .7-.1.2-.2.4-.4.6-.2.2-.4.4-.5.5-.2.2-.3.4-.2.7.2.3.7 1.2 1.5 1.9 1 .9 1.9 1.2 2.1 1.3.2.1.4.1.6-.1.2-.2.7-.8.9-1.1.2-.3.4-.2.7-.1.3.1 1.9.9 2.2 1.1.3.2.5.2.6.4.1.2.1 1-.2 1.6z" />
      </svg>
    ),
  },
];

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-[#3E4D36]/40 overflow-hidden" data-testid="site-footer">
      {/* Giant CTA band */}
      <div className="relative py-24 md:py-32 overflow-hidden border-b border-[#3E4D36]/40">
        <div className="absolute inset-0 radial-green opacity-50 pointer-events-none" />
        <div className="relative max-w-6xl mx-auto px-6 md:px-10 text-center">
          <span className="text-xs font-display uppercase tracking-[0.4em] text-[#BEDD7D]">
            / La misión empieza hoy
          </span>
          <h2 className="mt-6 font-display font-bold text-5xl md:text-7xl lg:text-8xl uppercase tracking-tighter leading-[0.95]">
            Tradea como un{" "}
            <span className="italic text-[#BEDD7D]">estratega</span>.
          </h2>
          <p className="mt-6 max-w-2xl mx-auto text-white/60 font-body text-lg">
            Cada decisión refleja principios. No operamos por impulso. Operamos con honor.
          </p>
          <a
            href="https://app.honor.trading/auth/login"
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-10 inline-flex items-center gap-2 px-10 py-5 bg-[#BEDD7D] text-black font-display font-bold text-sm uppercase tracking-[0.25em] hover:bg-white hover:shadow-[0_0_50px_rgba(190,221,125,0.7)] transition-all"
            data-testid="footer-cta-ingresar"
          >
            Ingresar a la plataforma
            <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>

        {/* Giant watermark */}
        <div className="absolute bottom-0 left-0 right-0 pointer-events-none overflow-hidden">
          <div className="font-display font-bold text-[20vw] leading-[0.8] tracking-tighter text-transparent [-webkit-text-stroke:1px_rgba(190,221,125,0.1)] text-center select-none whitespace-nowrap translate-y-[30%]">
            HONOR
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <HonorLogo className="h-14" variant="gold" />
            <p className="mt-6 max-w-md text-white/60 font-body text-sm leading-relaxed">
              Academia digital de trading. Formación, indicadores y comunidad diseñada para
              traders disciplinados y resilientes.
            </p>

            {/* Social Media Icons */}
            <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
              {SOCIALS.map((s) => (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  className="group w-10 h-10 rounded-full flex items-center justify-center border border-[#3E4D36] bg-[#1A2E1A]/40 text-white/70 hover:text-black hover:bg-[#BEDD7D] hover:border-[#BEDD7D] hover:shadow-[0_0_20px_rgba(190,221,125,0.4)] transition-all"
                  data-testid={`footer-social-${s.name.toLowerCase()}`}
                >
                  {s.icon}
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-xs font-display uppercase tracking-[0.3em] text-[#BEDD7D] mb-5">
              Plataforma
            </div>
            <ul className="space-y-3 text-sm font-body text-white/70">
              <li><a href="#academia" className="hover:text-[#BEDD7D]" data-testid="footer-link-academia">Academia</a></li>
              <li><a href="#rangos" className="hover:text-[#BEDD7D]" data-testid="footer-link-rangos">Rangos</a></li>
              <li><a href="#indicadores" className="hover:text-[#BEDD7D]" data-testid="footer-link-indicadores">Indicadores</a></li>
              <li><a href="#planes" className="hover:text-[#BEDD7D]" data-testid="footer-link-planes">Planes</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-display uppercase tracking-[0.3em] text-[#BEDD7D] mb-5">
              Contacto
            </div>
            <ul className="space-y-3 text-sm font-body text-white/70">
              <li>
                <a
                  href="https://wa.me/573136726029"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#BEDD7D]"
                  data-testid="footer-whatsapp"
                >
                  <Send className="w-3.5 h-3.5" /> WhatsApp
                </a>
              </li>
              <li>
                <a
                  href="https://app.honor.trading/auth/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#BEDD7D]"
                  data-testid="footer-login"
                >
                  Iniciar sesión
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#3E4D36]/40 flex flex-col md:flex-row items-center justify-between gap-4 text-xs font-body text-white/40">
          <div>© {new Date().getFullYear()} Honor Trading. Todos los derechos reservados.</div>
          <div className="font-display uppercase tracking-widest">Opera con honor.</div>
        </div>
      </div>
    </footer>
  );
}
